import React, { useState, useEffect } from 'react';
import styles from '../../styles/components/blogs/ScrollNavigation.module.css';

/**
 * ScrollNavigation Component
 * Displays scroll up/down arrows for page navigation
 */
const ScrollNavigation = () => {
    const [showScrollUp, setShowScrollUp] = useState(false);
    const [showScrollDown, setShowScrollDown] = useState(true);

    useEffect(() => {
        const handleScroll = () => {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            const scrollHeight = document.documentElement.scrollHeight;
            const clientHeight = document.documentElement.clientHeight;
            
            // Show scroll up button after scrolling down 300px
            setShowScrollUp(scrollTop > 300);
            
            // Hide scroll down button when near bottom (within 100px)
            setShowScrollDown(scrollTop + clientHeight < scrollHeight - 100);
        };

        // Initial check
        handleScroll();

        // Add scroll event listener
        window.addEventListener('scroll', handleScroll, { passive: true });

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    const scrollToBottom = () => {
        window.scrollTo({
            top: document.documentElement.scrollHeight,
            behavior: 'smooth'
        });
    };

    return (
        <div className={styles.scrollNavigation}>
            {/* Scroll Up Button */}
            {showScrollUp && (
                <button
                    onClick={scrollToTop}
                    className={`${styles.scrollButton} ${styles.scrollUp}`}
                    aria-label="Scroll to top"
                    title="Scroll to top"
                >
                    <svg 
                        width="24" 
                        height="24" 
                        viewBox="0 0 24 24" 
                        fill="none" 
                        stroke="currentColor" 
                        strokeWidth="2" 
                        strokeLinecap="round" 
                        strokeLinejoin="round"
                    >
                        <path d="M12 19V5M5 12l7-7 7 7"/>
                    </svg>
                </button>
            )}

            {/* Scroll Down Button */}
            {showScrollDown && (
                <button
                    onClick={scrollToBottom}
                    className={`${styles.scrollButton} ${styles.scrollDown}`}
                    aria-label="Scroll to bottom"
                    title="Scroll to bottom"
                >
                    <svg 
                        width="24" 
                        height="24" 
                        viewBox="0 0 24 24" 
                        fill="none" 
                        stroke="currentColor" 
                        strokeWidth="2" 
                        strokeLinecap="round" 
                        strokeLinejoin="round"
                    >
                        <path d="M12 5v14M19 12l-7 7-7-7"/>
                    </svg>
                </button>
            )}
        </div>
    );
};

export default ScrollNavigation;

